import { SYS_BORDER_RADIUS_MD, SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_XL, } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
export const StyledDescription = styled.div `
  ul {
    margin-top: 1rem;
    margin-bottom: 1rem;
    list-style: disc;
    list-style-position: inside;
    text-indent: calc(-1rem - 5px);
    margin-left: calc(1rem + 5px);

    li {
      list-style: inherit;
    }

    p:first-child {
      margin-top: 0;
    }
  }
`;
export const StyledStandardEquipmentSectionWrapper = styled.div `
  width: 100%;

  table {
    margin-top: ${SYS_SPACE_RELATIVE_XL};
    margin-bottom: ${SYS_SPACE_RELATIVE_XL};
  }

  td {
    padding: ${SYS_SPACE_FIXED_300} 0 !important;
  }

  tr:first-child > td {
    padding-top: 0 !important;
  }

  button {
    display: flex;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    > p {
      flex: 1;
    }
  }

  .custom-item {
    padding: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.sys.color.text.copy.default};
  }
`;
export const StyledSingleImage = styled.img `
  width: 100%;
  height: auto;
  object-fit: ${({ objectFit }) => objectFit};
  border-radius: ${SYS_BORDER_RADIUS_MD};
`;
